import React from "react";
import Slider from "react-slick";
import styled from "styled-components";

import slide2 from "../assets/slide2.jpg";
import slide16 from "../assets/supajosh2.jpg";
import slide15 from "../assets/slide15.png";
import slide14 from "../assets/supajosh.jpg";
import slide13 from "../assets/slide17.jpg";
import {Link} from "react-router-dom";

const About = () => {
    const About = styled.div`
        background: rgb(31, 1, 16);
        // border-bottom: 1px solid rgb(0, 195, 255);
    `;

    const AboutContent = styled.div`
        max-width: 1200px;
        margin: 0 auto;
    `;

    const MissionText = styled.div`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 10px;
        margin: 0 0 12px;
    `;

    const H1 = styled.h1`
        padding: 30px 0 0;
        color: rgb(0, 195, 255);
    `;

    const P = styled.p`
        padding: 2px;
        color: rgba(255, 255, 255, 0.8);
    `;

    const Container = styled.div`
        width: 100%;
        padding: 10px;
    `;

    const settings = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        pauseOnHover: true,
        arrows: false,
        speed: 1700,
        className: "center",
        centerMode: true,
        centerPadding: "-20px",
    };

    const Div = styled.div`
        padding-top: 16px;
        width: 50px;
        height: 600px;
        border-radius: 10px;

        @media (max-width: 769px) {
            height: 250px;
            padding: 1px;
        }
    `;

    const Img = styled.img`
        width: 90%;
        height: 90%;
        border-radius: 10px;
        object-fit: cover;

        transition: all 0.3s linear;
        &:hover {
            transform: scale(1.03);
        }
    `;

    return (
        <About>
            <AboutContent>
                <MissionText>
                    <H1>Our Mission</H1>
                    <P>
                        To Provide A Platform For Emerging Artists With Diverse Voice, While Pushing InnovativeMusical
                        Boundaries, Bridging Together World Communication And Merging Cultural Difference.
                    </P>
                    <H1>Our Vision</H1>
                    <P>Changing The Atmosphere One Song At A Time!</P>
                </MissionText>
                <Container className="slider-container">
                    <Slider {...settings}>
                        <Div>
                            <Link to="/artists">
                                <Img src={slide2} alt="img" />
                            </Link>
                        </Div>
                        <Div>
                            <Link to="/artists">
                                <Img src={slide16} alt="img" />
                            </Link>
                        </Div>
                        <Div>
                            <Link to="/artists">
                                <Img src={slide15} alt="img" />
                            </Link>
                        </Div>{" "}
                        <Div>
                            <Link to="/artists">
                                <Img src={slide14} alt="img" />
                            </Link>
                        </Div>{" "}
                        <Div>
                            <Link to="/artists">
                                <Img src={slide13} alt="img" />
                            </Link>
                        </Div>
                    </Slider>
                </Container>
            </AboutContent>
        </About>
    );
};

export default About;
